/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  configInstruction: {
    id: 'searchDetailsConfig.configInstruction',
    defaultMessage:
      'Map your data schema from Discovery to the title, body, and URL fields below then check the preview to review your configuration.'
  },
  fieldOptionPlaceholder: {
    id: 'searchDetailsConfig.fieldOptionPlaceholder',
    defaultMessage: 'Choose a field or leave it blank as None...'
  },
  fieldTitle: {
    id: 'searchDetailsConfig.fieldTitle',
    defaultMessage: 'Title'
  },
  fieldBody: {
    id: 'searchDetailsConfig.fieldBody',
    defaultMessage: 'Body'
  },
  fieldUrl: {
    id: 'searchDetailsConfig.fieldUrl',
    defaultMessage: 'URL'
  },
  loading: {
    id: 'searchDetailsConfig.loading',
    defaultMessage: 'Loading...'
  }
});
